















import cautionLabel from "@/frontend/components/form/cautionLabel.vue";
import inputLabel from "@/frontend/components/form/inputLabel.vue";

export default {
  components: {
    cautionLabel,
    inputLabel,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    caution: {
      type: String,
      default: "",
    },
    prop: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    step: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  computed: {
    bindValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.updateValue(val);
      },
    },
    autoCompValue() {
      return this.type === "password" ? "off" : "on";
    },
    noPadding() {
      return { "no-padding": this.caution };
    },
  },
  methods: {
    updateValue(newValue) {
      if (this.value !== newValue) {
        this.$emit("input", newValue);
      }
    },
  },
};
